import Alert from "react-bootstrap/Alert";

const Error = ({ message, variant }) => {
    return (
        <>
            <div
                style={{
                    display: "flex",
                    height: "100vh",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Alert variant={variant}>{message}</Alert>
            </div>
        </>
    );
};

export default Error;
